import * as actionTypes from './actionTypes';
import { BrandVehicleModel } from '@app/src/views/StepOne/form/models/brandVehicle';

interface State {
  data: BrandVehicleModel[];
  isFetching: boolean;
  error: boolean;
  selected: string;
  message: string;
}

const initialState: State = {
  data: [],
  isFetching: false,
  error: false,
  selected: '',
  message: ''
}

export const brandVehicle = (state = initialState, action): State => {
  switch (action.type) {
    case actionTypes.FETCH_BRAND_VEHICLE_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_BRAND_VEHICLE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_BRAND_VEHICLE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    case actionTypes.SET_BRAND_VEHICLE_MESSAGE:
      return {
        ...state,
        message: action.message
      }
    case actionTypes.CLEAR_BRAND_VEHICLE_MESSAGE:
      return {
        ...state,
        message: ''
      }
    case actionTypes.CLEAR_BRAND_VEHICLE_DATA:
      return {
        ...state,
        data: [],
        message: ''
      }
    case actionTypes.SET_BRAND_VEHICLE_SELECTED:
      return {
        ...state,
        selected: action.selected
      }
    case actionTypes.CLEAR_BRAND_VEHICLE_SELECTED:
      return {
        ...state,
        selected: ''
      }
    default:
      return state;
  }
}
